import { render, staticRenderFns } from "./select-size.vue?vue&type=template&id=ed47a2ba&"
import script from "./select-size.vue?vue&type=script&lang=js&"
export * from "./select-size.vue?vue&type=script&lang=js&"
import style0 from "./select-size.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed47a2ba')) {
      api.createRecord('ed47a2ba', component.options)
    } else {
      api.reload('ed47a2ba', component.options)
    }
    module.hot.accept("./select-size.vue?vue&type=template&id=ed47a2ba&", function () {
      api.rerender('ed47a2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/select-size.vue"
export default component.exports